/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenGoal Platform API
 * Agency-facing API — day-to-day platform usage by agency users.
 * OpenAPI spec version: 1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreatePlayerDto,
  ImportSquadDto,
  ImportSquadPreviewDto,
  ImportSquadPreviewResponseDto,
  ImportSquadResultDto,
  PlayerCareerDto,
  PlayerDto,
  PlayersControllerListPlayersV1200,
  PlayersControllerListPlayersV1Params,
  RemovePlayerResponseDto,
  UpdatePlayerDto
} from '../model';

import { apiRequest } from '../../client.ts';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getPlayersControllerListPlayersV1Url = (params?: PlayersControllerListPlayersV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/players?${stringifiedParams}` : `/v1/players`
}

/**
 * Paginated, searchable and orderable, with filters for position (optionally including secondary positions), club, league, nationality, representation, contract status, age range, contract-expiry window and shortlist. Every filter composes, and all of them run in the database so `meta.total` always describes the same set as `data`.
 * @summary List the caller's players
 */
export const playersControllerListPlayersV1 = async (params?: PlayersControllerListPlayersV1Params, options?: RequestInit): Promise<PlayersControllerListPlayersV1200> => {

  return apiRequest<PlayersControllerListPlayersV1200>(getPlayersControllerListPlayersV1Url(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlayersControllerListPlayersV1QueryKey = (params?: PlayersControllerListPlayersV1Params,) => {
    return [
    `/v1/players`, ...(params ? [params] : [])
    ] as const;
    }


export const getPlayersControllerListPlayersV1QueryOptions = <TData = Awaited<ReturnType<typeof playersControllerListPlayersV1>>, TError = unknown>(params?: PlayersControllerListPlayersV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof playersControllerListPlayersV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlayersControllerListPlayersV1QueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof playersControllerListPlayersV1>>> = ({ signal }) => playersControllerListPlayersV1(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof playersControllerListPlayersV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PlayersControllerListPlayersV1QueryResult = NonNullable<Awaited<ReturnType<typeof playersControllerListPlayersV1>>>
export type PlayersControllerListPlayersV1QueryError = unknown


export function usePlayersControllerListPlayersV1<TData = Awaited<ReturnType<typeof playersControllerListPlayersV1>>, TError = unknown>(
 params: undefined |  PlayersControllerListPlayersV1Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof playersControllerListPlayersV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof playersControllerListPlayersV1>>,
          TError,
          Awaited<ReturnType<typeof playersControllerListPlayersV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlayersControllerListPlayersV1<TData = Awaited<ReturnType<typeof playersControllerListPlayersV1>>, TError = unknown>(
 params?: PlayersControllerListPlayersV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof playersControllerListPlayersV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof playersControllerListPlayersV1>>,
          TError,
          Awaited<ReturnType<typeof playersControllerListPlayersV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlayersControllerListPlayersV1<TData = Awaited<ReturnType<typeof playersControllerListPlayersV1>>, TError = unknown>(
 params?: PlayersControllerListPlayersV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof playersControllerListPlayersV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the caller's players
 */

export function usePlayersControllerListPlayersV1<TData = Awaited<ReturnType<typeof playersControllerListPlayersV1>>, TError = unknown>(
 params?: PlayersControllerListPlayersV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof playersControllerListPlayersV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPlayersControllerListPlayersV1QueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getPlayersControllerCreatePlayerV1Url = () => {




  return `/v1/players`
}

/**
 * Creates a record owned by the caller’s agency. `clubId` must name a club from the global catalog (`GET /v1/clubs`) or be omitted for a free agent; the league is read through the club and is never sent. Upload a photo first via `POST /v1/uploads/presign` and pass the returned key as `photoKey`.
 * @summary Add a player to the agency
 */
export const playersControllerCreatePlayerV1 = async (createPlayerDto: CreatePlayerDto, options?: RequestInit): Promise<PlayerDto> => {

  return apiRequest<PlayerDto>(getPlayersControllerCreatePlayerV1Url(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createPlayerDto)
  }
);}





export const getPlayersControllerCreatePlayerV1QueryKey = (createPlayerDto?: CreatePlayerDto,) => {
    return [
    'POST', `/v1/players`, createPlayerDto
    ] as const;
    }


export const getPlayersControllerCreatePlayerV1QueryOptions = <TData = Awaited<ReturnType<typeof playersControllerCreatePlayerV1>>, TError = unknown>(createPlayerDto: CreatePlayerDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof playersControllerCreatePlayerV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlayersControllerCreatePlayerV1QueryKey(createPlayerDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof playersControllerCreatePlayerV1>>> = ({ signal }) => playersControllerCreatePlayerV1(createPlayerDto, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof playersControllerCreatePlayerV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PlayersControllerCreatePlayerV1QueryResult = NonNullable<Awaited<ReturnType<typeof playersControllerCreatePlayerV1>>>
export type PlayersControllerCreatePlayerV1QueryError = unknown


export function usePlayersControllerCreatePlayerV1<TData = Awaited<ReturnType<typeof playersControllerCreatePlayerV1>>, TError = unknown>(
 createPlayerDto: CreatePlayerDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof playersControllerCreatePlayerV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof playersControllerCreatePlayerV1>>,
          TError,
          Awaited<ReturnType<typeof playersControllerCreatePlayerV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlayersControllerCreatePlayerV1<TData = Awaited<ReturnType<typeof playersControllerCreatePlayerV1>>, TError = unknown>(
 createPlayerDto: CreatePlayerDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof playersControllerCreatePlayerV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof playersControllerCreatePlayerV1>>,
          TError,
          Awaited<ReturnType<typeof playersControllerCreatePlayerV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlayersControllerCreatePlayerV1<TData = Awaited<ReturnType<typeof playersControllerCreatePlayerV1>>, TError = unknown>(
 createPlayerDto: CreatePlayerDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof playersControllerCreatePlayerV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Add a player to the agency
 */

export function usePlayersControllerCreatePlayerV1<TData = Awaited<ReturnType<typeof playersControllerCreatePlayerV1>>, TError = unknown>(
 createPlayerDto: CreatePlayerDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof playersControllerCreatePlayerV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPlayersControllerCreatePlayerV1QueryOptions(createPlayerDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getPlayersControllerPreviewImportV1Url = () => {




  return `/v1/players/import/preview`
}

/**
 * Fetches and normalises without writing anything. Each candidate carries a status (`ready`, `needs_review`, `already_imported`) and human-readable warnings for whatever did not map. `providerRowCount` is what the provider actually returned — on the free key that is roughly ten people per club, coaching staff included.
 * @summary Preview a club's squad from the data provider
 */
export const playersControllerPreviewImportV1 = async (importSquadPreviewDto: ImportSquadPreviewDto, options?: RequestInit): Promise<ImportSquadPreviewResponseDto> => {

  return apiRequest<ImportSquadPreviewResponseDto>(getPlayersControllerPreviewImportV1Url(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(importSquadPreviewDto)
  }
);}





export const getPlayersControllerPreviewImportV1QueryKey = (importSquadPreviewDto?: ImportSquadPreviewDto,) => {
    return [
    'POST', `/v1/players/import/preview`, importSquadPreviewDto
    ] as const;
    }


export const getPlayersControllerPreviewImportV1QueryOptions = <TData = Awaited<ReturnType<typeof playersControllerPreviewImportV1>>, TError = unknown>(importSquadPreviewDto: ImportSquadPreviewDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof playersControllerPreviewImportV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlayersControllerPreviewImportV1QueryKey(importSquadPreviewDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof playersControllerPreviewImportV1>>> = ({ signal }) => playersControllerPreviewImportV1(importSquadPreviewDto, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof playersControllerPreviewImportV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PlayersControllerPreviewImportV1QueryResult = NonNullable<Awaited<ReturnType<typeof playersControllerPreviewImportV1>>>
export type PlayersControllerPreviewImportV1QueryError = unknown


export function usePlayersControllerPreviewImportV1<TData = Awaited<ReturnType<typeof playersControllerPreviewImportV1>>, TError = unknown>(
 importSquadPreviewDto: ImportSquadPreviewDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof playersControllerPreviewImportV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof playersControllerPreviewImportV1>>,
          TError,
          Awaited<ReturnType<typeof playersControllerPreviewImportV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlayersControllerPreviewImportV1<TData = Awaited<ReturnType<typeof playersControllerPreviewImportV1>>, TError = unknown>(
 importSquadPreviewDto: ImportSquadPreviewDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof playersControllerPreviewImportV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof playersControllerPreviewImportV1>>,
          TError,
          Awaited<ReturnType<typeof playersControllerPreviewImportV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlayersControllerPreviewImportV1<TData = Awaited<ReturnType<typeof playersControllerPreviewImportV1>>, TError = unknown>(
 importSquadPreviewDto: ImportSquadPreviewDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof playersControllerPreviewImportV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Preview a club's squad from the data provider
 */

export function usePlayersControllerPreviewImportV1<TData = Awaited<ReturnType<typeof playersControllerPreviewImportV1>>, TError = unknown>(
 importSquadPreviewDto: ImportSquadPreviewDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof playersControllerPreviewImportV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPlayersControllerPreviewImportV1QueryOptions(importSquadPreviewDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getPlayersControllerImportSquadV1Url = () => {




  return `/v1/players/import`
}

/**
 * Writes only the rows you selected. The server re-fetches from the provider rather than trusting the preview payload, so send identifiers and overrides — not player data. Rows that cannot be written (no position, no date of birth) are reported in `skipped` rather than failing the whole import.
 * @summary Import the selected players from a club’s squad
 */
export const playersControllerImportSquadV1 = async (importSquadDto: ImportSquadDto, options?: RequestInit): Promise<ImportSquadResultDto> => {

  return apiRequest<ImportSquadResultDto>(getPlayersControllerImportSquadV1Url(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(importSquadDto)
  }
);}





export const getPlayersControllerImportSquadV1QueryKey = (importSquadDto?: ImportSquadDto,) => {
    return [
    'POST', `/v1/players/import`, importSquadDto
    ] as const;
    }


export const getPlayersControllerImportSquadV1QueryOptions = <TData = Awaited<ReturnType<typeof playersControllerImportSquadV1>>, TError = unknown>(importSquadDto: ImportSquadDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof playersControllerImportSquadV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlayersControllerImportSquadV1QueryKey(importSquadDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof playersControllerImportSquadV1>>> = ({ signal }) => playersControllerImportSquadV1(importSquadDto, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof playersControllerImportSquadV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PlayersControllerImportSquadV1QueryResult = NonNullable<Awaited<ReturnType<typeof playersControllerImportSquadV1>>>
export type PlayersControllerImportSquadV1QueryError = unknown


export function usePlayersControllerImportSquadV1<TData = Awaited<ReturnType<typeof playersControllerImportSquadV1>>, TError = unknown>(
 importSquadDto: ImportSquadDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof playersControllerImportSquadV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof playersControllerImportSquadV1>>,
          TError,
          Awaited<ReturnType<typeof playersControllerImportSquadV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlayersControllerImportSquadV1<TData = Awaited<ReturnType<typeof playersControllerImportSquadV1>>, TError = unknown>(
 importSquadDto: ImportSquadDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof playersControllerImportSquadV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof playersControllerImportSquadV1>>,
          TError,
          Awaited<ReturnType<typeof playersControllerImportSquadV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlayersControllerImportSquadV1<TData = Awaited<ReturnType<typeof playersControllerImportSquadV1>>, TError = unknown>(
 importSquadDto: ImportSquadDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof playersControllerImportSquadV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Import the selected players from a club’s squad
 */

export function usePlayersControllerImportSquadV1<TData = Awaited<ReturnType<typeof playersControllerImportSquadV1>>, TError = unknown>(
 importSquadDto: ImportSquadDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof playersControllerImportSquadV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPlayersControllerImportSquadV1QueryOptions(importSquadDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getPlayersControllerFindOneV1Url = (id: string,) => {




  return `/v1/players/${id}`
}

/**
 * @summary One player
 */
export const playersControllerFindOneV1 = async (id: string, options?: RequestInit): Promise<PlayerDto> => {

  return apiRequest<PlayerDto>(getPlayersControllerFindOneV1Url(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlayersControllerFindOneV1QueryKey = (id: string,) => {
    return [
    `/v1/players/${id}`
    ] as const;
    }


export const getPlayersControllerFindOneV1QueryOptions = <TData = Awaited<ReturnType<typeof playersControllerFindOneV1>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof playersControllerFindOneV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlayersControllerFindOneV1QueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof playersControllerFindOneV1>>> = ({ signal }) => playersControllerFindOneV1(id, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof playersControllerFindOneV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PlayersControllerFindOneV1QueryResult = NonNullable<Awaited<ReturnType<typeof playersControllerFindOneV1>>>
export type PlayersControllerFindOneV1QueryError = unknown


export function usePlayersControllerFindOneV1<TData = Awaited<ReturnType<typeof playersControllerFindOneV1>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof playersControllerFindOneV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof playersControllerFindOneV1>>,
          TError,
          Awaited<ReturnType<typeof playersControllerFindOneV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlayersControllerFindOneV1<TData = Awaited<ReturnType<typeof playersControllerFindOneV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof playersControllerFindOneV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof playersControllerFindOneV1>>,
          TError,
          Awaited<ReturnType<typeof playersControllerFindOneV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlayersControllerFindOneV1<TData = Awaited<ReturnType<typeof playersControllerFindOneV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof playersControllerFindOneV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One player
 */

export function usePlayersControllerFindOneV1<TData = Awaited<ReturnType<typeof playersControllerFindOneV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof playersControllerFindOneV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPlayersControllerFindOneV1QueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getPlayersControllerUpdatePlayerV1Url = (id: string,) => {




  return `/v1/players/${id}`
}

/**
 * Omitted fields are left untouched. Sent fields are validated exactly as on create.
 * @summary Update a player
 */
export const playersControllerUpdatePlayerV1 = async (id: string,
    updatePlayerDto: UpdatePlayerDto, options?: RequestInit): Promise<PlayerDto> => {

  return apiRequest<PlayerDto>(getPlayersControllerUpdatePlayerV1Url(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updatePlayerDto)
  }
);}





export const getPlayersControllerUpdatePlayerV1QueryKey = (id: string,
    updatePlayerDto?: UpdatePlayerDto,) => {
    return [
    'PATCH', `/v1/players/${id}`, updatePlayerDto
    ] as const;
    }


export const getPlayersControllerUpdatePlayerV1QueryOptions = <TData = Awaited<ReturnType<typeof playersControllerUpdatePlayerV1>>, TError = unknown>(id: string,
    updatePlayerDto: UpdatePlayerDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof playersControllerUpdatePlayerV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlayersControllerUpdatePlayerV1QueryKey(id,updatePlayerDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof playersControllerUpdatePlayerV1>>> = ({ signal }) => playersControllerUpdatePlayerV1(id,updatePlayerDto, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof playersControllerUpdatePlayerV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PlayersControllerUpdatePlayerV1QueryResult = NonNullable<Awaited<ReturnType<typeof playersControllerUpdatePlayerV1>>>
export type PlayersControllerUpdatePlayerV1QueryError = unknown


export function usePlayersControllerUpdatePlayerV1<TData = Awaited<ReturnType<typeof playersControllerUpdatePlayerV1>>, TError = unknown>(
 id: string,
    updatePlayerDto: UpdatePlayerDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof playersControllerUpdatePlayerV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof playersControllerUpdatePlayerV1>>,
          TError,
          Awaited<ReturnType<typeof playersControllerUpdatePlayerV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlayersControllerUpdatePlayerV1<TData = Awaited<ReturnType<typeof playersControllerUpdatePlayerV1>>, TError = unknown>(
 id: string,
    updatePlayerDto: UpdatePlayerDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof playersControllerUpdatePlayerV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof playersControllerUpdatePlayerV1>>,
          TError,
          Awaited<ReturnType<typeof playersControllerUpdatePlayerV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlayersControllerUpdatePlayerV1<TData = Awaited<ReturnType<typeof playersControllerUpdatePlayerV1>>, TError = unknown>(
 id: string,
    updatePlayerDto: UpdatePlayerDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof playersControllerUpdatePlayerV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Update a player
 */

export function usePlayersControllerUpdatePlayerV1<TData = Awaited<ReturnType<typeof playersControllerUpdatePlayerV1>>, TError = unknown>(
 id: string,
    updatePlayerDto: UpdatePlayerDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof playersControllerUpdatePlayerV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPlayersControllerUpdatePlayerV1QueryOptions(id,updatePlayerDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getPlayersControllerRemovePlayerV1Url = (id: string,) => {




  return `/v1/players/${id}`
}

/**
 * A hard delete, taking shortlist entries with it. The audit entry recording the deletion survives.
 * @summary Delete a player
 */
export const playersControllerRemovePlayerV1 = async (id: string, options?: RequestInit): Promise<RemovePlayerResponseDto> => {

  return apiRequest<RemovePlayerResponseDto>(getPlayersControllerRemovePlayerV1Url(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getPlayersControllerRemovePlayerV1QueryKey = (id: string,) => {
    return [
    'DELETE', `/v1/players/${id}`
    ] as const;
    }


export const getPlayersControllerRemovePlayerV1QueryOptions = <TData = Awaited<ReturnType<typeof playersControllerRemovePlayerV1>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof playersControllerRemovePlayerV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlayersControllerRemovePlayerV1QueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof playersControllerRemovePlayerV1>>> = ({ signal }) => playersControllerRemovePlayerV1(id, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof playersControllerRemovePlayerV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PlayersControllerRemovePlayerV1QueryResult = NonNullable<Awaited<ReturnType<typeof playersControllerRemovePlayerV1>>>
export type PlayersControllerRemovePlayerV1QueryError = unknown


export function usePlayersControllerRemovePlayerV1<TData = Awaited<ReturnType<typeof playersControllerRemovePlayerV1>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof playersControllerRemovePlayerV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof playersControllerRemovePlayerV1>>,
          TError,
          Awaited<ReturnType<typeof playersControllerRemovePlayerV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlayersControllerRemovePlayerV1<TData = Awaited<ReturnType<typeof playersControllerRemovePlayerV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof playersControllerRemovePlayerV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof playersControllerRemovePlayerV1>>,
          TError,
          Awaited<ReturnType<typeof playersControllerRemovePlayerV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlayersControllerRemovePlayerV1<TData = Awaited<ReturnType<typeof playersControllerRemovePlayerV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof playersControllerRemovePlayerV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Delete a player
 */

export function usePlayersControllerRemovePlayerV1<TData = Awaited<ReturnType<typeof playersControllerRemovePlayerV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof playersControllerRemovePlayerV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPlayersControllerRemovePlayerV1QueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getPlayersControllerFindCareerV1Url = (id: string,) => {




  return `/v1/players/${id}/career`
}

/**
 * Spells plus totals and per-90 rates, all derived on read. The per-90 figures are null without minutes played, because appearances are not a substitute for them.
 * @summary The player's career history and totals
 */
export const playersControllerFindCareerV1 = async (id: string, options?: RequestInit): Promise<PlayerCareerDto> => {

  return apiRequest<PlayerCareerDto>(getPlayersControllerFindCareerV1Url(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlayersControllerFindCareerV1QueryKey = (id: string,) => {
    return [
    `/v1/players/${id}/career`
    ] as const;
    }


export const getPlayersControllerFindCareerV1QueryOptions = <TData = Awaited<ReturnType<typeof playersControllerFindCareerV1>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof playersControllerFindCareerV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlayersControllerFindCareerV1QueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof playersControllerFindCareerV1>>> = ({ signal }) => playersControllerFindCareerV1(id, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof playersControllerFindCareerV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PlayersControllerFindCareerV1QueryResult = NonNullable<Awaited<ReturnType<typeof playersControllerFindCareerV1>>>
export type PlayersControllerFindCareerV1QueryError = unknown


export function usePlayersControllerFindCareerV1<TData = Awaited<ReturnType<typeof playersControllerFindCareerV1>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof playersControllerFindCareerV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof playersControllerFindCareerV1>>,
          TError,
          Awaited<ReturnType<typeof playersControllerFindCareerV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlayersControllerFindCareerV1<TData = Awaited<ReturnType<typeof playersControllerFindCareerV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof playersControllerFindCareerV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof playersControllerFindCareerV1>>,
          TError,
          Awaited<ReturnType<typeof playersControllerFindCareerV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlayersControllerFindCareerV1<TData = Awaited<ReturnType<typeof playersControllerFindCareerV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof playersControllerFindCareerV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The player's career history and totals
 */

export function usePlayersControllerFindCareerV1<TData = Awaited<ReturnType<typeof playersControllerFindCareerV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof playersControllerFindCareerV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPlayersControllerFindCareerV1QueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






